import Vue from 'vue';
import PrismicVue from 'prismic-vue';
import VueScrollTo from 'vue-scrollto';
import VueScrollReveal from 'vue-scroll-reveal';
import Vuelidate from 'vuelidate';
import VueFormGenerator from 'vue-form-generator';
import SequentialEntrance from 'vue-sequential-entrance';

import App from './App.vue';
import router from './router';
import store from './store';
import linkResolver from './prismic/link-resolver';
import htmlSerializer from './prismic/html-serializer';
import 'vue-form-generator/dist/vfg.css';
import 'vue-sequential-entrance/vue-sequential-entrance.css';

Vue.config.productionTip = false;

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer,
});

Vue.use(VueScrollTo);
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal',
  duration: 300,
  distance: '75px',
  origin: 'right',
  mobile: true,
  viewFactor: 0,
});
Vue.use(Vuelidate);
Vue.use(VueFormGenerator);
Vue.use(SequentialEntrance);

require('./assets/sass/main.scss');

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
